export default () => [25, 50, 100, 200, 400]
